
if ( !window.AsteikkoArticleUi ) ( function( $ ) {
  // Immediately Invoked Function Expression: start

  "use strict";
  
  if ( typeof $ !== "function" || typeof $.prototype.jquery !== "string" ) {
    throw( "AsteikkoArticleUi.js: jQuery is not loaded" );
  }
  if ( !window.Code || !window.Code.PhotoSwipe ) {
    throw( "AsteikkoArticleUi.js: PhotoSwipe is not loaded" );
  }
  
	$( document ).keyup( function( e ) {
		// Esc
		if ( e.keyCode === 27 ) {
		  AsteikkoArticleUi.closeOverlaysInside( "#asmag-issue" );
		}
	} );
  
  // Make it possible to jump to an image even when a PhotoSwipe carousel is 
  // already open, by clicking on the carousel link (e.g. image thumbnail).
  // Notice: this is designed for PhotoSwipe-jQuery 3.0.5.
  var origPSTriggerElementClick = window.Code.PhotoSwipe.onTriggerElementClick;
  // Override the original PhotoSwipe onclick handler
  window.Code.PhotoSwipe.onTriggerElementClick = function( e ) {
  
    e.preventDefault();
    var i;
	  var linkElems = this.originalImages;
    
    if ( this.carousel ) {
      for ( i = 0; i < linkElems.length; i++ ) {
        if ( e.currentTarget === linkElems[ i ] ) {
          this.carousel.show( i );
        }
      }
    }
    else {
      origPSTriggerElementClick.call( this, e );
    }
  };
  
  function onOverlayShown() {
    $( this ).trigger( 'AsteikkoArticleUi-overlayShown' );
  }
  function onOverlayHidden() {
    $( this ).trigger( 'AsteikkoArticleUi-overlayHidden' );
  }

  var AsteikkoArticleUi = {};

  AsteikkoArticleUi.overlayFadeInSpeed = 300;
  AsteikkoArticleUi.overlayFadeOutSpeed = 200;

  /*
   * Opens an overlay with the given id.
   */
  AsteikkoArticleUi.openOverlay = function( overlayId ) {
    
    var closeButton;
    var isOpen;
    var overlay = $( "#"+ overlayId );
    if ( !overlay.length ) return;
    
    isOpen = overlay.data( "is_open" );
    if ( isOpen ) return;
    
    // Close all other overlays
    AsteikkoArticleUi.closeOverlaysInside( overlay.closest( ".asmag-page" ) );
    
    // Create the close-button if it doesn't exist yet
    closeButton = overlay.find( ".close-button" ).eq( 0 );
    if ( !closeButton.length ) {
      closeButton = $( "<div class='close-button' />" ).prependTo( overlay );
      closeButton.click( function() {
        AsteikkoArticleUi.closeOverlay( overlayId );
      } );
      new NoClickDelay( closeButton.get( 0 ) );
    }
    
    overlay.removeData( "is_open" );
    overlay.data( "is_open", true );
    overlay.fadeIn( AsteikkoArticleUi.overlayFadeInSpeed, onOverlayShown );
    // overlay.show();
  };

  /*
   * Closes an overlay that is bound to this button.
   */
  AsteikkoArticleUi.closeOverlay = function( overlayId ) {
    
    var isOpen;
    var overlay = $( "#"+ overlayId );
    if ( !overlay.length ) return;
    
    isOpen = overlay.data( "is_open" );
    if ( !isOpen ) return;
    
    overlay.removeData( "is_open" );
    overlay.data( "is_open", false );
    overlay.fadeOut( AsteikkoArticleUi.overlayFadeOutSpeed, onOverlayHidden );
    // overlay.hide();
  };
  
  AsteikkoArticleUi.closeOverlaysInside = function( parentElem ) {
    
    var parent = $( parentElem );
    if ( !parent.length ) return;
    parent.
      find( ".overlay" ).
      hide().
      removeData( "is_open" ).
      data( "is_open", false ).
      each( function() {
        if ( $( this ).is( ':visible' ) ) {
          onOverlayHidden.call( this );
        }
      } );
  };
  
  AsteikkoArticleUi.toggleOverlay = function( overlayId ) {
    
    var isOpen;
    var overlay = $( "#"+ overlayId );
    if ( !overlay.length ) return;
    
    isOpen = overlay.data( "is_open" );
    if ( isOpen ) AsteikkoArticleUi.closeOverlay( overlayId );
    else AsteikkoArticleUi.openOverlay( overlayId );
  };
  
  var unescapeHtml = function( str ) {
    return str
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, "\"")
        .replace(/&#039;/g, "'");
  };
  
  var getPsImageCaption = function( el ) {
  
    var i;
    var j;
    var childEl;
    var matches;
    var altText = "";
    var altTextHtml = "";
    var caption = document.createElement( "div" );
    
    if ( el.nodeName.toLowerCase() === "img" ) {
      altText = el.getAttribute( 'alt' );
    }
    else {
      for ( i = 0, j = el.childNodes.length; i < j; i++ ) {
        childEl = el.childNodes[ i ];
        if ( childEl.nodeName.toLowerCase() === 'img' ) {
          altText = childEl.getAttribute( 'alt' );
          break;
        }
      }
    }
    
    if ( altText ) {
      altText = unescapeHtml( altText );
      altText = altText.replace( /\s+/g, " " );
      // Show product name with different typography than the rest of the caption
      matches = altText.match( /^([\s\S]+?)((?:■+\s*)+)([\s\S]+)$/i );
      if ( matches && matches.length >= 3 && !( /[<>]/g ).test( altText ) ) {
        altTextHtml = "<span class='alkukorostus'>"+ matches[1] +
          "</span> <span class='nelio'>■</span> ";
        if ( matches.length === 4 ) altTextHtml += matches[3];
        altTextHtml = altTextHtml.replace( /<\/span> <span class='nelio'>■<\/span>\s*$/, "" );
        caption.innerHTML = altTextHtml;
      }
      else {
        caption.innerHTML = altText;
      }
      // Caption should only have padding if it has content, to prevent the 
      // caption elem taking too much screen space.
      caption.style.paddingTop = "1em";
      caption.style.paddingBottom = "1em";
    }
    return caption;
  };
  
  var getPsToolbar = function() {
    return '<div class="ps-toolbar-play" style="padding-top: 12px;">Play</div><div class="ps-toolbar-previous" style="padding-top: 12px;"></div><div class="ps-toolbar-next" style="padding-top: 12px;"></div><div class="ps-toolbar-close" style="padding-top: 12px;"></div>';
  };
  
  
  
  /*
   * Creates a PhotoSwipe gallery given a set of a-elements. linkElems can be 
   * a jQuery selector, a set of HTML elements or a jQuery result set.
   */
  AsteikkoArticleUi.createPSGallery = function( linkElems ) {
    
    linkElems = $( linkElems ).filter( "a" ).has( "img" );
    if ( !linkElems.length ) return;
    
    var ps;
    var pageElem;
    var pageElemId;
    var psTargetContainer;
    var psTarget;
    
    if ( linkElems.length ) {
      pageElem = linkElems.eq( 0 ).closest( ".asmag-page" );
      if ( !pageElem.length ) throw( "AsteikkoArticleUi.createPSGallery: No page elem found" );
      psTargetContainer = pageElem.find( ".ps-target-container" );
      // If the page has no PhotoSwipe target, use a global target. Androids 
      // will always use window as the target.
      if ( $( ".isandroid" ).length ) {
        psTarget = $( window );
      }
      else if ( !psTargetContainer.length ) {
        psTarget = $( "#asteikkoarticleui-ps-target-global" );
        psTargetContainer = $( "#asteikkoarticleui-ps-target-global-container" );
        // Create the global PS target if it doesn't exist
        if ( !psTarget.length ) {
          psTargetContainer = $( "<div id='asteikkoarticleui-ps-target-global-container' /> )" ).
            append( $( "<div id='asteikkoarticleui-ps-target-global' />" ) ).
            appendTo( "#asmag-issue" );
          psTarget = $( "#asteikkoarticleui-ps-target-global" );
          if ( !psTarget.length ) psTarget = $( window );
        }
      }
      else {
        psTarget = psTargetContainer.find( ".ps-target" );
        psTarget.unbind( "touchstart mousedown" ).bind( "touchstart mousedown", 
          function( event ) {
            event.stopPropagation();
          } );
      }
      ps = linkElems.photoSwipe( {
        target: psTarget.get( 0 ),
        loop: false, 
        captionAndToolbarFlipPosition: true, 
        enableMouseWheel: false, 
        enableKeyboard: true, 
        maxUserZoom: '2.0', 
        minUserZoom: '1.0', 
        captionAndToolbarAutoHideDelay: 0, 
        swipeThreshold: '100', 
        swipeTimeThreshold: '200', 
        preventSlideshow: true, 
        captionAndToolbarShowEmptyCaptions: true, 
        imageScaleMethod: 'fitNoUpscale', 
        captionAndToolbarOpacity: 1.0,
        zIndex: 30,
        getToolbar: getPsToolbar,
        getImageCaption: getPsImageCaption/*,
        cacheMode: Code.PhotoSwipe.Cache.Mode.aggressive*/
      } );
      if ( psTargetContainer.length && psTarget.get( 0 ) !== window ) {
        ps.addEventHandler( window.Code.PhotoSwipe.EventTypes.onHide, function( e ) {
          psTarget.empty();
          psTargetContainer.css( "display", "none" );
        } );
        ps.addEventHandler( window.Code.PhotoSwipe.EventTypes.onBeforeShow, function( e ) {
          psTargetContainer.fadeIn( 200 );
        } );
      }
    }
  };

  window.AsteikkoArticleUi = AsteikkoArticleUi;

  // Immediately Invoked Function Expression: end
} )( window.jQuery );